import { chatterBodyToPlainText } from 'pages/Salesforce/components/SalesforceChatter/utils';
import {
  CrmNotification,
  CrmNotificationType
} from 'types/SalesforceCrmNotifications.types';
import { subStringText, translate } from 'utils';

const NOTIFICATION_BODY_PREVIEW_LENGTH = 120;

const getCrmNotificationActionText = (type: CrmNotificationType): string => {
  switch (type) {
    case CrmNotificationType.POST_MENTION:
      return translate('salesforce.notifications.action.post_mention');
    case CrmNotificationType.COMMENT_MENTION:
      return translate('salesforce.notifications.action.comment_mention');
    case CrmNotificationType.COMMENT_REPLY:
      return translate('salesforce.notifications.action.comment_reply');
    default:
      return '';
  }
};

export const formatCrmNotificationMessage = (
  notification: CrmNotification
): string => {
  const actorName =
    notification.data?.actorName ??
    translate('salesforce.notifications.unknown_actor');
  const action = getCrmNotificationActionText(notification.type);
  const relatedName =
    notification.relatedName ??
    translate('salesforce.notifications.unknown_record');
  const relatedType = notification.relatedType ?? '';

  return translate('salesforce.notifications.message', {
    actorName,
    action,
    relatedName,
    relatedType
  });
};

export const formatCrmNotificationBodyPreview = (
  notification: CrmNotification
): string => {
  const plainText = chatterBodyToPlainText(notification.data?.body);
  if (!plainText) return '';

  return subStringText(plainText, NOTIFICATION_BODY_PREVIEW_LENGTH);
};
